<template>
    <div>
      <div class="customizer-links" :class="{ open: customizer }">
        <div class="nav flex-column nac-pills" id="c-pills-tab" role="tablist" aria-orientation="vertical">
          <customizerOpen />
          <customizerLayout />
         
        </div>
      </div>
      <div class="customizer-contain" :class="{ open: customizer }">
        <div class="tab-content" id="c-pills-tabContent">
          <customConfig />
          <div class="customizer-body custom-scrollbar">
             <customColor /> 
            <customSetting />
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import { mapState } from 'vuex';
    import customizerOpen from './customizerOpen.vue';
    import customizerLayout from './customizerLayout.vue';
     import customConfig from './customConfig.vue';
     import customColor from './customColor.vue';
      import customSetting from './customSetting.vue';
    
  
    export default {
      name: 'indexPage',
      components : {
        
        
        
        customizerOpen,
        customizerLayout,
        customConfig,
         customColor,
          customSetting
      },
      computed: {
        ...mapState({
          customizer: (state) => state.menu.customizer,
        }),
      },
    };
  </script>